// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1NpFg","radioRow":"SimpleQuestionBuilderModal_radioRow__pmeQP"};